import { Component, effect, input, Input, OnChanges, OnInit, signal, SimpleChanges, ViewChild } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button'
import { MatTableModule, MatRow, MatTableDataSource } from '@angular/material/table'
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule, MatSort } from '@angular/material/sort';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialog } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { MatCheckbox } from '@angular/material/checkbox'
import { InvoiceService } from '../../../services/invoice.service';
import { InvoiceListRequest } from '../../../models/invoice.model';
import { NotificationService } from '../../../services/notificationservice';
import { LookUpService } from '../../../services/lookupservice';
import { CommonModule, DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { NgFor, NgIf } from '@angular/common';
import { style, state, trigger, transition, animate } from '@angular/animations';
import { FeedstockService } from '../../../services/feedstockservice';
import { FilterState, GeneratorsList, GetMarketGeneratorsResponse } from '../../../interfaces/generatorsmodel';
import { AlertDialogComponent,AlertDialogData } from '../../shared/components/alert-dialog/alert-dialog.component';
import { Subject, takeUntil } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { IdName } from '../../../interfaces/pricematrixmodel';
import { SelectSearchComponent } from "../../shared/components/select-search/select-search.component";
import { MatSelectItems } from '../../../interfaces/lookup';
import { arrayBuffer } from 'stream/consumers';
type MonthItem = { value: number; label: string };
@Component({
  selector: 'app-toteinvoice',
  standalone: true,
 imports: [MatIcon, MatTableModule, MatRow, MatPaginatorModule, MatSortModule, MatFormFieldModule,
    MatInputModule, MatButtonModule, MatSelectModule, MatDatepickerModule, FormsModule,
    MatMenuModule, MatProgressBarModule, MatProgressSpinnerModule, MatCardModule, MatSelectModule, CommonModule, SelectSearchComponent],
  templateUrl: './toteinvoice.component.html',
  styleUrl: './toteinvoice.component.scss'
})

export class ToteinvoiceComponent {
  constructor(private _lookupService: LookUpService,private _invoiceService: InvoiceService, private dialog: MatDialog,
      private _fsService: FeedstockService, private _notificationService: NotificationService,) {

      this.loadCustomers();
      this.toteInvoiceSearch();
      effect(() => {      
        const customerId = this.selectedCustomerId();   
        this.loadStreamss(customerId!.toString());
      });    
  }
  selectCustomerItems:MatSelectItems[]=[];
  selectStreamItems:MatSelectItems[]=[];  
  statusInfo: MatSelectItems[] = [];
  statusCode: string = '';
  statusData: any[] = [];
  private destroy$ = new Subject<void>();
  displayedColumns: string[] = ['workOrderNumber','response', 'statusCode', 'request'];
  dataSource = new MatTableDataSource<any>;
  
  customer = signal<GetMarketGeneratorsResponse[]>([]);
  selectedCustomerId = signal<number | null>(-1);
  customerQuery = signal<string>('');
  streamId:number = 0;
 
  // control = new FormControl<number | null>(null);
  streamsList: IdName[] = [];  
  filteredStreams: IdName[] = [];
  customers: GetMarketGeneratorsResponse[] = [];
  Filteredcustomers: GetMarketGeneratorsResponse[] = [];
  @Input() locale = 'en-US';
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  selectedYear = new Date().getFullYear();
  selectedMonth = new Date().getMonth();
  
  months: MonthItem[] = Array.from({ length: 12 }, (_, i) => {
    const monthIndex = i; // 0..11
    const value = i + 1;  // 1..12
    const label = new Intl.DateTimeFormat(this.locale, { month: 'long' })
      .format(new Date(2025, monthIndex, 1));
    return { value, label };
  });

  currentYear = new Date().getFullYear();
  years = [this.currentYear, this.currentYear - 1];

  // filterState = input<FilterState | null>(null);
  refreshTrigger = input<number>(0);
  gridSearchText = input<string | null>(null);
   
  loadCustomers() {
    this._lookupService.getStatusInfo().pipe(takeUntil(this.destroy$)).subscribe({
      next: (status: any[]) => {
        console.log('status:', status);
        this.statusData = status;
        this.statusInfo = this.statusData.map(item => ({
          id: item.id!,
          name: item.name!
        }));
      }
    })
    this._fsService.getToteGenerators("-1").pipe(takeUntil(this.destroy$)).subscribe({
      next: (customersres: GetMarketGeneratorsResponse[]) => {
        this.customer.set(customersres);
        this.Filteredcustomers = [...customersres];
        this.selectCustomerItems = [...customersres].map(item => ({
          id: item.id!,
          name: item.customerName!
        }));
        // this.dataSource.data = this.customers;
        // this.dataSource.paginator = this.paginator;
        // this.dataSource.sort = this.sort;
      }
    });    
  }

  onStatusReceived(event: number | null){    
    //this.direction = event;
    if (event === -1 || event === null) {
      this.statusCode = '';
    } else {
      // Find the item matching the numeric ID and extract its code
      const selectedStatus = this.statusData.find(i => i.id === event);
      this.statusCode = selectedStatus ? selectedStatus.code : '';
    }
  }

  onCustomerReceived(event : number | null) {
    this.selectedCustomerId.set(event ?? 0); 
  }

  onStreamReceived(event : number | null) {
    this.streamId = event ?? -1;
  }
  loadStreamss(Id:string) {
    if (Id === '-1') {Id="0";}
    this._fsService.getToteStreamList(Id).pipe(takeUntil(this.destroy$)).subscribe({
      next: (streamsres: IdName[]) => {
          this.streamsList = streamsres  ;
          this.filteredStreams = streamsres  ;
           this.selectStreamItems = this.filteredStreams.map(item => ({
            id: item.id!,
            name: item.name!
          }));
      }
    });
  }

  showPayloadRequest(requestPayload: string){
    requestPayload = JSON.parse(requestPayload);
    const dialogData: AlertDialogData = {
      title: 'Payload Request',
      message:requestPayload
    };
    this.dialog.open(AlertDialogComponent, {
      width: '650px',
      maxWidth: '650px',
      data: dialogData,
      disableClose: true
    });
  }

  toteInvoiceSearch(){
    var invoicerequest: InvoiceListRequest = {
      CustomerId: 0,
      StreamId: 0,
      Year: this.selectedYear,
      Month: this.selectedMonth,
      StartDate: '',
      EndDate: '',
      Status: this.statusCode,
      WorkOrderNumber: ''
    };

    this._invoiceService.getToteInvoice(invoicerequest).pipe(takeUntil(this.destroy$)).subscribe({
      next: (invoicelistres: any[]) => {
        this.dataSource.data = invoicelistres;
      }
    });
  }
  
  trackByFn(index: number, item: any) {
    return item.id;
  }  
  
  filterCustomers(event: Event): void {
    const searchTerm = (event.target as HTMLInputElement).value.toLowerCase();
    if (!searchTerm) {
      this.Filteredcustomers = [...this.customer()];
    } else {
      this.Filteredcustomers = this.customer().filter(
        customer => customer.customerName.toLowerCase().includes(searchTerm)
      );
    }
  }

  filterStreams(event: Event): void {
    const searchTerm = (event.target as HTMLInputElement).value.toLowerCase();
    if (!searchTerm) {
      this.filteredStreams = [...this.streamsList];
    } else {
      this.filteredStreams = this.streamsList.filter(
        stream => stream.name.toLowerCase().includes(searchTerm)
      );
    } 
  }
  onCustomerSelected(customerId: number): void {
    this.selectedCustomerId.set(customerId);
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
}
